<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import { ywlxgltj_xzywlx } from '@/api/ywlxgz';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'ywlxzt_ywgz_ywlxgl_ywlxgltj',
    components: {},
    props: {
        ywlxgltjdialog: {
            type: Boolean,
            default: false
        },
        ywzx: {
            type: String,
            default: '1'
        },
        data: {
            type: Object,
            default: null
        }
    },
    watch: {
        data: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.formdata = this.data;
                });
            }
        }
    },
    data: function() {
        return {
            formlist: getdata().formlist,
            formdata: getdata().formdata,
            ywzl: comMapping.$ywzx,
            qzfw: comMapping.$qzfw,
            rules: getdata().rules
        };
    },
    mounted() {
    },
    created() {
    },
    methods: {
        closediag() {
            this.$emit('closediag', false);
            this.cleanData();
        },
        cleanData() {
            this.formdata = {
                bsType: this.ywzx,
                resRange: '',
                bsName: '',
                code: ''
            };
        },
        getdata(e) {
        },
        saveywlxgl() {
            if (!this.formdata.resRange) {
                this.$message.error('请选择取值范围!');
                return;
            }
             if (!this.formdata.bsName) {
                this.$message.error('请输入业务名称!');
                return;
            }
            let params = JSON.parse(JSON.stringify(this.formdata));
            //params.setofbooksId = this.ztid;
            if (this.formdata.id && this.formdata.id !== 0) {
                params.id = this.formdata.id;
            }
            ywlxgltj_xzywlx(params).then((res) => {
                if (res.data.code === '1') {
                    this.$message.success('保存成功！');
                    this.$emit('closediag', false);
                    this.cleanData();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
